/**
 * Login del portale acquisti.
 *
 * Volutamente piu' scarna di quella di manutenzioni: qui entrano solo utenti interni
 * `@peralbahc.com`, che sono Federated Member nel tenant CIAM e quindi fanno SSO con
 * l'account aziendale — nessuna password da chiedere, nessun OTP, nessuna modalita' dev.
 *
 * Il messaggio d'errore piu' probabile su questo dominio e' «hai l'identita' ma non il ruolo»:
 * `requireCorporate` rifiuta chi non e' Admin / Ufficio Acquisti / Direzione, e la risposta va
 * detta chiaramente invece di lasciare una pagina vuota.
 */

import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@shared/context/AuthContext";

export default function LoginPage() {
  const { isAuthenticated, loading, error, login, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner w-12 h-12" />
      </div>
    );
  }

  if (isAuthenticated && user) {
    return <Navigate to="/contratti" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="bg-acquisti-800 text-white px-6 py-5">
          <h1 className="text-xl font-semibold">PHC · Portale Acquisti</h1>
          <p className="text-sm text-acquisti-200 mt-1">
            Contratti, capitolati e albo fornitori
          </p>
        </div>

        <div className="p-6 space-y-4">
          {error && (
            <div className="rounded-md bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-800">
              {error}
            </div>
          )}

          {isAuthenticated && !user && (
            <div className="rounded-md bg-yellow-50 border border-yellow-200 px-4 py-3 text-sm text-yellow-900">
              L'accesso è riuscito ma il tuo utente non è abilitato al portale
              acquisti. Serve un record utente attivo con ruolo Ufficio
              Acquisti, Direzione o Admin: scrivi a{" "}
              <a className="underline" href="mailto:assistenza@peralbahc.com">
                assistenza@peralbahc.com
              </a>
              .
            </div>
          )}

          <p className="text-sm text-gray-600">
            L'accesso è riservato agli utenti interni{" "}
            <strong>@peralbahc.com</strong> e usa le credenziali aziendali
            Microsoft.
          </p>

          <button
            type="button"
            onClick={login}
            className="btn-primary w-full text-base py-3"
          >
            Accedi con l'account aziendale
          </button>

          <p className="text-xs text-gray-500 text-center pt-2">
            Cerchi le manutenzioni?{" "}
            <a className="underline" href="https://manutenzioni.peralbahc.com">
              manutenzioni.peralbahc.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
